import { useLang } from '@/i18n';
import css from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';

interface ItfItem {
    name: string;
    text: string;
    img: string;
}
const J: React.FC = () => {
    const { t } = useLang('stream.overview');
    const items: ItfItem[] = [
        {
            name: t('J_item1_name'),
            text: t('J_item1_text'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1774596580479/Frame%202094654947.png',
        },
        {
            name: t('J_item2_name'),
            text: t('J_item2_text'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1774596580841/Frame%202094654949.png',
        },
        {
            name: t('J_item3_name'),
            text: t('J_item3_text'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1774596581025/Frame%202094654950.png',
        },
        {
            name: t('J_item4_name'),
            text: t('J_item4_text'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1774596580635/Frame%202094654948.png',
        },
        {
            name: t('J_item5_name'),
            text: t('J_item5_text'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1774596580236/Frame%202094654956.png',
        },
    ];

    return (
        <div className={`${css.section} stream-nl-J GtmModuleData-section space`} id="stream-nl-J" data-section-id={'stream-nl-J'}>
            <div className="wrapper">
                <EcoImg
                    className="bg-img"
                    pc="https://websiteoss.ecoflow.com/upload/image/1782976404298/20260702-151311.webp"
                    pad="https://websiteoss.ecoflow.com/upload/image/1774853456135/j1m.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1774853456135/j1m.jpg"
                    alt={t('J_title')}
                />
                <div className="msg">
                    <div className="msg-top">
                        <span className="text1">{t('J_text1')}</span>
                        <span className="text2">{t('J_text2')}</span>
                        <span className="text3">{t('J_text3')}</span>
                    </div>
                    {/* <p className="desc">{t('J_desc')}</p> */}
                </div>
            </div>
            <div className="info">
                <h2 className="title">{t('J_title')}</h2>
            </div>
            <div className="cards">
                <ul className="items">
                    {[...items, ...items]?.map((item: ItfItem) => (
                        <li className="item" key={item.name}>
                            <EcoImg className="item-img" pc={item.img} alt={item.name} />
                            <p className="item-name">{item.name}</p>
                            <p className="item-text">{item.text}</p>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default J;
